import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';

const EmailVerificationBanner: React.FC = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState('');

  // Don't show banner if user is verified, dismissed, or not logged in
  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const handleResendEmail = async () => {
    setResending(true);
    setMessage('');

    try {
      const response = await api.post('/auth/resend-verification-email');
      setMessage(response.data.message);

      // Auto-clear success message after 5 seconds
      setTimeout(() => setMessage(''), 5000);
    } catch (error: any) {
      setMessage(error.response?.data?.detail || 'Failed to resend email. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: '100px', // Below the navbar
      left: 0,
      right: 0,
      backgroundColor: '#ffe8d6',
      borderBottom: '2px solid #ff9f5a',
      padding: '12px 20px',
      zIndex: 1039,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      marginLeft: 'var(--sidebar-visible, 0)',
      width: 'calc(100% - var(--sidebar-visible, 0))'
    }}>
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2 flex-grow-1">
            <i className="fas fa-envelope" style={{ color: '#8b4513', fontSize: '18px' }}></i>
            <div>
              <strong style={{ color: '#8b4513' }}>Email Verification Required</strong>
              <p style={{ margin: 0, color: '#8b4513', fontSize: '14px' }}>
                We sent a verification email to <strong>{user.email}</strong>.
                Please check your inbox and click the verification link to confirm your email address.
                This ensures you receive order confirmations and important notifications.
              </p>
              {message && (
                <p style={{ margin: '5px 0 0 0', color: message.includes('Failed') ? '#dc3545' : '#28a745', fontSize: '13px', fontWeight: '500' }}>
                  {message}
                </p>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button
              onClick={handleResendEmail}
              disabled={resending}
              style={{
                backgroundColor: '#ff9f5a',
                color: '#ffffff',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: resending ? 'not-allowed' : 'pointer',
                whiteSpace: 'nowrap',
                opacity: resending ? 0.7 : 1
              }}
            >
              {resending ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Sending...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane me-2"></i>
                  Resend Email
                </>
              )}
            </button>
            <button
              onClick={() => setDismissed(true)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#8b4513',
                fontSize: '20px',
                cursor: 'pointer',
                padding: '0 8px',
                lineHeight: '1'
              }}
              aria-label="Dismiss"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
